import { MAP_TYPES } from '@deck.gl/carto';

const TRACTS_BY_TRACTCODES_SOURCE_ID = 'tractsByTractcodesSource';

function source(tractcodes, year, socioeconomicFactors = []) {
  let whereClause = '';

  year = parseInt(year);

  tractcodes.forEach((tractcode, index) => {
    if (index === 0) {
      whereClause += 'WHERE (';
    }
    whereClause += `STARTS_WITH(CAST(tractcode AS string), '${tractcode}')`;
    if (index < tractcodes.length - 1) {
      whereClause += ' OR ';
    } else {
      whereClause += ')';
    }
  });

  whereClause += ` AND observations.year = ${year}`;

  let socioeconomicFactorsParsed =
    socioeconomicFactors.length > 0 ? `, ${socioeconomicFactors.join(', ')}` : '';

  return {
    id: TRACTS_BY_TRACTCODES_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        broadband, tracts.countyname AS countyname, tracts.statename AS statename, year, geom, tracts.tractcode, ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, "tract" AS type ${socioeconomicFactorsParsed}
      FROM
        carto-dw-ac-cn5bemsi.shared.tracts AS tracts
      JOIN
        carto-dw-ac-cn5bemsi.shared.tract_geometries AS geometry ON tracts.geoid = geometry.geoid
      JOIN
        carto-dw-ac-cn5bemsi.shared.tract_observations AS observations ON observations.geoid = geometry.geoid
      ${whereClause}
    `,
    queryParameters: {
      tractcodes,
      year,
    },
  };
}

export default source;
